"use client";

import { AppPageTitle } from "@/widgets";
import InfoSection from "@/widgets/app/page/wezon/InfoSection";
import { SsgoiTransition } from "@ssgoi/react";

export default function WezonPage() {
  return (
    <SsgoiTransition id="/app/pages/wezon">
      <div className="max-[991px]:pt-16 flex pt-24 w-full flex-col">
        <AppPageTitle />
      </div>

      <div className="w-full flex-col">
        <InfoSection />
      </div>
    </SsgoiTransition>
  );
}
